import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import type { SnackbarAction } from 'notistack';

import { NotiStackButton } from '../components/NotiStackButton';

export const useViewSnackbarAction = () => {
  const navigate = useNavigate();
  const { closeSnackbar } = useSnackbar();

  const buildViewSnackbarAction = useCallback(
    (path: string): SnackbarAction => {
      const ViewSnackbarActionButton: SnackbarAction = (snackbarId) => (
        <NotiStackButton
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => {
            void navigate(path);
            closeSnackbar(snackbarId);
          }}
          variant="text"
        >
          Consulter
        </NotiStackButton>
      );

      return ViewSnackbarActionButton;
    },
    [closeSnackbar, navigate],
  );

  return { buildViewSnackbarAction };
};
